import React from 'react';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaArrowRight, FaTrophy, FaUsers, FaMedal, FaHeart } from 'react-icons/fa';
import './About.css';

const FitnessConditioningTraining = () => {

    return (
        <div className="about-page">
            {/* Main About Section */}
            <section className="about-main section">
                <div className="container">
                    <div className="about-main-grid">
                        <div className="about-main-content">
                            <h2>Fitness & Conditioning Training</h2>
                            <p>
                                The Fitness & Conditioning Training program at Net Nest Badminton Sports Club is designed to enhance the physical abilities required to perform at peak levels in badminton. This program focuses on building strength, speed, endurance, agility, and flexibility—key elements that support skill execution and reduce the risk of injury.
                            </p>
                            <p>
                                <h2>Program Overview</h2>
                                Badminton is a fast-paced and physically demanding sport that requires excellent fitness and quick reactions. Our Fitness & Conditioning Training program complements on-court coaching by improving overall athletic performance. It is suitable for players of all ages and skill levels and is tailored according to individual fitness needs.
                            </p>
                        </div>
                        <div className="about-main-images">
                            <img src="img/Fitness & Conditioning Training.jpg" alt="Badminton Court" className="main-image" />
                        </div>
                    </div>
                    <div className="about-main-grid">
                        <div className="about-main-content">
                            <h2>Strength & Power Development</h2>
                            <p>
                                Core strengthening exercises
                                <br></br>
                                Lower body strength for fast footwork and stability
                                <br></br>
                                Upper body conditioning for powerful strokes
                                <br></br>
                                Controlled bodyweight and resistance exercises
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Speed, Agility & Quickness</h2>
                            <p>
                                Agility ladder drills
                                <br></br>
                                Speed and reaction exercises
                                <br></br>
                                Directional movement training
                                <br></br>
                                Balance and coordination drills
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Endurance & Stamina Building</h2>
                            <p>
                                Cardiovascular conditioning
                                <br></br>
                                Continuous rally simulations
                                <br></br>
                                Interval training routines
                                <br></br>
                                Breathing and recovery techniques
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Flexibility & Injury Prevention</h2>
                            <p>
                                Dynamic warm-up routines
                                <br></br>
                                Stretching and mobility exercises
                                <br></br>
                                Cool-down and recovery practices
                                <br></br>
                                Joint stability and posture correction
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Mental Focus & Physical Discipline</h2>
                            <p>
                                Fitness training also builds mental toughness and discipline. Players learn to push their limits, stay focused, and develop resilience. This mental strength translates into better performance during training and competition.
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Customized Fitness Plans</h2>
                            <p>
                                Each player’s fitness level is assessed regularly, and training routines are adjusted accordingly. Customized fitness plans ensure safe progression, balanced workload, and optimal results.
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Who Should Join This Program?</h2>
                            <p>
                                Beginner to advanced badminton players
                                <br></br>
                                Competitive athletes seeking improved performance
                                <br></br>
                                Players focusing on fitness and injury prevention
                                <br></br>
                                Individuals looking to enhance overall athletic ability
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default FitnessConditioningTraining;
